import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "A space is a mood",
    body:
      "We begin with feeling. Before geometry, before palette — we listen for what a space should make you feel, and then compose backwards from there.",
    image: "/manifesto/chapter-01.webp",
  },
  {
    n: "02",
    title: "Material speaks first",
    body:
      "Travertine, walnut, lime, linen, brass — we sample honestly, close to the source, and let the material do most of the talking.",
    image: "/manifesto/chapter-02.webp",
  },
  {
    n: "03",
    title: "Light is the last brief",
    body:
      "Every surface we specify is a rehearsal for how light will find it — at 7am, at dusk, on a monsoon Sunday.",
    image: "/manifesto/chapter-03.webp",
  },
];

export default function Manifesto() {
  return (
    <section className="bg-bone" data-testid="manifesto-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-40">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-4">
            <p className="text-[11px] uppercase tracking-[0.3em] text-muteInk">— Manifesto</p>
          </div>
          <div className="col-span-12 md:col-span-8">
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-ink">
              Three quiet convictions that shape<br />
              <span className="italic text-clay">every space we make.</span>
            </h2>
          </div>
        </div>

        <div className="space-y-24 md:space-y-40">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.n}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
              className={`grid grid-cols-12 gap-6 md:gap-10 items-center ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
            >
              <div className="col-span-12 md:col-span-6 md:[direction:ltr]">
                <div className="clip-frame w-full h-[380px] md:h-[560px] hoverable">
                  <img src={c.image} alt={c.title} className="w-full h-full object-cover" />
                </div>
              </div>
              <div className="col-span-12 md:col-span-6 md:[direction:ltr]">
                <div className="flex items-baseline gap-6">
                  <span className="chapter-num text-6xl md:text-8xl">{c.n}</span>
                  <span className="text-[11px] uppercase tracking-[0.28em] text-muteInk">Chapter</span>
                </div>
                <h3 className="font-serif text-3xl md:text-5xl mt-6 leading-[1.02] tracking-tight text-ink">{c.title}</h3>
                <p className="mt-6 text-ink/75 leading-relaxed max-w-md">{c.body}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
